import { useRecommendedForYouQuery } from '../../../generated/frontend'
import { RecommendedForYouContainer } from './components/RecommendedForYouContainer/RecommendedForYouContainer'
import type { Layout } from './layouts'

type RecommendedForYouProps = {
  whichId: string
  layout: Layout
}

export const RecommendedForYou = ({ whichId, layout }: RecommendedForYouProps) => {
  const { data, loading } = useRecommendedForYouQuery()
  if (loading) {
    return null
  }

  const { recommendations } = data?.homePage ?? {}

  if (recommendations?.models && recommendations.models.length > 0) {
    return (
      <RecommendedForYouContainer
        recommendations={recommendations}
        whichId={whichId}
        layout={layout}
      />
    )
  }

  return null
}
